import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICharityQuery} from "../../models/charity/query";
import {ICharity, ICharityDetails} from "../../models/charity/response";
import {ICreateCharity, IUpdateCharity} from "../../models/charity/request";
import {IDonation} from "../../models/donation/response";
import {IDonationQuery} from "../../models/donation/query";
import {IDonationServiceDetails} from "../../models/donation-service/response";

class DonationService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllDonations = (query: IDonationQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<IDonation>>({
            path: `/donations`,
            method: "GET",
            query,
            ...params,
        });

    getDonation = (id: number, params?: RequestParams) =>
        this.http.request<IDonation>({
            path: `/donations/${id}`,
            method: "GET",
            ...params,
        });
}

export default DonationService;